import { render, staticRenderFns } from "./HeaderAccountButton.vue?vue&type=template&id=467b86be&scoped=true&"
import script from "./HeaderAccountButton.vue?vue&type=script&lang=js&"
export * from "./HeaderAccountButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAccountButton.vue?vue&type=style&index=0&id=467b86be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b86be",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fheader-account-button%2FHeaderAccountButton.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports